/**
 * Dialer Test API — 工作室「撥號名單」匯入 + 檢視
 *
 * Backend endpoints:
 *   POST   /api/dialer-test-import/start   (multipart) → { jobId }
 *   GET    /api/dialer-test-import/jobs/:jobId         → { job }
 *   DELETE /api/dialer-test-import/jobs/:jobId
 *
 *   GET    /api/avatar/:id/members                       → 進線會員 directory
 *   GET    /api/avatar/:id/test-dialer-setup             → 外播 contacts + greetingTemplates
 *   PUT    /api/avatar/:id/test-dialer-setup
 *   DELETE /api/avatar/:id/test-dialer-setup
 */
import { api, get, put, del } from './client.js';

const BUILDER_BASE = '/ivr-builder/api/dialer-test-import';

export async function startDialerImport({ avatarId, mode, file, flowDoc, importMode = 'append', instructions = null }) {
    const fd = new FormData();
    fd.append('avatarId', avatarId);
    fd.append('mode', mode); // 'inbound' | 'outbound'
    fd.append('importMode', importMode);
    fd.append('file', file);
    if (flowDoc) fd.append('flowDoc', flowDoc);
    if (instructions) fd.append('instructions', instructions);
    return api('POST', `${BUILDER_BASE}/start`, { body: fd });
}

export async function getDialerJob(jobId) {
    return get(`${BUILDER_BASE}/jobs/${encodeURIComponent(jobId)}`);
}

export async function deleteDialerJob(jobId) {
    return del(`${BUILDER_BASE}/jobs/${encodeURIComponent(jobId)}`);
}

export async function fetchTestDialerSetup(avatarId) {
    const r = await get(`/api/avatar/${encodeURIComponent(avatarId)}/test-dialer-setup`);
    return r?.testDialerSetup || null;
}

export async function saveTestDialerSetup(avatarId, testDialerSetup) {
    return put(`/api/avatar/${encodeURIComponent(avatarId)}/test-dialer-setup`, { testDialerSetup });
}

export async function deleteTestDialerSetup(avatarId) {
    return del(`/api/avatar/${encodeURIComponent(avatarId)}/test-dialer-setup`);
}
